// extracted by mini-css-extract-plugin
export default {"MobileNav":"MobToggleBtn_MobileNav__4ltqK"};